import React from 'react'

import { paths } from '@mc/paths'

import Image from 'components/LegacyImage'
import Link from 'components/Link/CustomLink'
import { CourseMeta } from 'types/data'

export const InstructorInfo = ({
  courseMeta,
  onClick,
}: {
  courseMeta: CourseMeta
  onClick: () => void
}) => (
  <Link
    ariaHidden
    href={paths.courseTypePage(courseMeta.contentType, courseMeta.courseSlug)}
    tabIndex={-1}
    onClick={onClick}
    passHref
    className='mc-mt-3 d-flex'
  >
    <div className='mc-mr-3'>
      <Image
        src={courseMeta.instructorHeadshotSrc}
        width={32}
        height={32}
        layout='fixed'
        className='mc-corners--circle flex-1 flex-shrink-0'
        alt=''
      />
    </div>

    <div>
      <h3 className='mc-text-small mc-text--bold'>{courseMeta.courseTitle}</h3>
      <p className='mc-text-x-small mc-text--2-lines'>
        {courseMeta.instructorName}
      </p>
    </div>
  </Link>
)
